import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import '@kuaizhan/kmanage-font';
import App from './App';
import reducers from './stores/reducers';
import ds from './requests/ds';
import './styles/index.less';


const initialState = window.INITIAL_STATE;
const middleware = [thunk];

const store = createStore(
    reducers,
    initialState,
    applyMiddleware(...middleware),
);

ReactDOM.render(
  <Provider store={store}>
    <App ds={ds} />
  </Provider>, document.getElementById('root')
);
